import React, { useContext, useRef, useState } from "react";
import trans, { isRTL } from "../../../../utils";
import { livetrackingcontext } from "../../../../context/LiveTrackingContext";
import TrackedGeofenceAction from "./TrackedGeofenceAction";
import TrackedStopEngineAction from "./TrackedStopEngineAction";
import { toast } from "react-toastify";
import TrackedAlertsActions from "./TrackedAlertsActions";

export function ActionBtns({ styling, title, imgSrc, fun }) {
	return (
		<div className={`tracked-quick-actions-btns ${styling}`} onClick={fun}>
			<img src={imgSrc} alt={title} />
			<span className={isRTL ? "me-2" : "ms-2"}>{trans(title)}</span>
		</div>
	);
}

export default function TrackedQuickActions() {
	const [title, setTitle] = useState(null);
	const [glowSelect, setGlowSelect] = useState(false);
	const actionsRef = useRef(null);

	const { setMultipleSelect, multipleSelect, vehiclesIds, alerts, setAlerts } =
		useContext(livetrackingcontext);

	const isRtl = localStorage.getItem("lang") === "ar";

	const triggerSelectGlow = () => {
		setGlowSelect(true);

		// scroll logic
		if (actionsRef.current) {
			actionsRef.current.scrollTo({
				left: isRtl ? actionsRef.current.scrollWidth : 0,
				behavior: "smooth",
			});
		}

		setTimeout(() => {
			setGlowSelect(false);
		}, 1000);
	};

	const clickHandler = (name) => {
		if (vehiclesIds.length === 0) {
			toast.info(
				trans("Please select at least one vehicle to perform this action."),
				{
					autoClose: 800,
					rtl: isRtl,
				},
			);

			triggerSelectGlow();
		} else {
			setTitle(name);
		}
	};

	return (
		<>
			<div className="tracked-quick-actions position-relative" ref={actionsRef}>
				<ActionBtns
					title="Select Vehicles"
					imgSrc={`${process.env.PUBLIC_URL}/assets/New/LiveTracking/Checkmark.svg`}
					styling={`tracked-quick-actions-btn ${
						glowSelect ? "glow-highlight" : ""
					}`}
					fun={() => setMultipleSelect(!multipleSelect)}
				/>

				<ActionBtns
					title="Stop Engine"
					imgSrc={`${process.env.PUBLIC_URL}/assets/New/LiveTracking/PowerOff.svg`}
					styling="tracked-quick-actions-engine-off"
					fun={() => clickHandler("stop engine")}
				/>

				<ActionBtns
					title="Set Geofence"
					imgSrc={`${process.env.PUBLIC_URL}/assets/New/LiveTracking/Geofence.svg`}
					styling="tracked-quick-actions-btn"
					fun={() => clickHandler("set geofence")}
				/>
				<ActionBtns
					title="Alerts"
					imgSrc={`${process.env.PUBLIC_URL}/assets/New/LiveTracking/Alerts.svg`}
					styling="tracked-quick-actions-btn"
					fun={() => setAlerts(true)}
				/>

				<TrackedGeofenceAction title={title} setTitle={setTitle} />
				<TrackedStopEngineAction title={title} setTitle={setTitle} />
			</div>
			{alerts && <TrackedAlertsActions />}
		</>
	);
}
